// Polyfill for mic-recorder-to-mp3 library
// The library uses lamejs which expects Node.js-style module system and specific globals

// First, ensure we have a global lamejs object that the LAME encoder can attach to
// eslint-disable-next-line @typescript-eslint/no-explicit-any
if (!(globalThis as any).lamejs) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (globalThis as any).lamejs = {};
}

// Polyfill require function for browser environment if it doesn't exist
// eslint-disable-next-line @typescript-eslint/no-explicit-any
if (!(globalThis as any).require) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (globalThis as any).require = function (moduleName: string) {
    // For lamejs modules, return constructor functions that return empty objects
    // This allows the lamejs code to load without errors
    if (moduleName.includes('.js') || moduleName.includes('./')) {
      // Return a constructor function for lamejs modules
      return function () {
        return {};
      };
    }

    // For other modules, return empty objects
    return {};
  };
}

// Ensure module exports polyfill exists
// eslint-disable-next-line @typescript-eslint/no-explicit-any
if (!(globalThis as any).module) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (globalThis as any).module = { exports: {} };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
if (!(globalThis as any).exports) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (globalThis as any).exports = {};
}

// Common LAME encoder globals that might be expected
const globals = [
  'Lame',
  'Presets',
  'LAME',
  'LameGlobalFlags',
  'BitrateHistogram',
  'Version',
  'VBRMode',
  'MPEGMode',
  'PaddingType',
  'Encoder',
  'mpglib',
  'GainAnalysis',
  'Quantize',
  'Reservoir',
  'Takehiro',
  'QuantizePVT',
  'VBRTag',
  'Mp3Encoder',
  'WavHeader',
  'BitStream',
  'PsyModel',
  'LameInternalFlags',
  'ATH',
  'ReplayGain',
  'CBRNewIterationLoop',
  'Tables',
  'common',
  'System',
  'Float',
  'ShortBlock',
  'Util',
  'Arrays'
];

globals.forEach((globalName) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (!(globalName in (globalThis as any))) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (globalThis as any)[globalName] = {};
  }
});

export {};
